import loadable from "@loadable/component";

import type { PageBlockRegistry } from "../../core/page-blocks/Block.component";
import { localBlockComponents, localMicrositeComponents } from "../local/registry-block";

const CLAYBUCK_GUESTS_HINT = "display-hints/clay-buck-guests";

const ClayBuckGuests = loadable(() => import("./components/feed/ClayBuckGuests.component"));

export const clayBuckBlockComponents: PageBlockRegistry = {
  ...localBlockComponents,
  feed: block => (block?.tags?.includes(CLAYBUCK_GUESTS_HINT) ? ClayBuckGuests : localBlockComponents.feed(block)),
};

export const clayBuckMicrositeComponents: PageBlockRegistry = {
  ...localMicrositeComponents,
};
